$(document).ready(function () {
    checkboxSlider.init();
});

// Functionality to remove the default "Unselected" class off the label when the user has never toggled the checkbox "On" (selected) or "Off" (deselected)
var checkboxSlider = {};

checkboxSlider.bind = function () {
    for (var i = 0; i < checkboxSlider.labelSwitch.length; i++) {

        checkboxSlider.labelSwitch[i].addEventListener("click", function () {

            if (this.classList.contains(checkboxSlider.labelSwitchUnsetClass)) {
                this.classList.remove(checkboxSlider.labelSwitchUnsetClass);
            }
        });
    };
};

checkboxSlider.init = function () {

    if (document.getElementsByClassName("switch-toggle").length > 0) {

        checkboxSlider.labelSwitch = document.getElementsByClassName("switch-toggle");
        checkboxSlider.labelSwitchUnsetClass = "switch-toggle--unset";

        checkboxSlider.bind();
    }
};